module.exports = __webpack_public_path__ + "static/media/profPic.986e0639.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/profPic.png
// module id = 100
// module chunks = 0